import { AxiosRequestConfig } from 'axios';
import { logger } from 'shared/lib';

import { getAuthHeader } from '../utils/get-auth-header';

export const requestInterceptor = (config: AxiosRequestConfig) => {
  const authHeader = getAuthHeader();
  if (authHeader) {
    if (!config.headers) config.headers = {};

    config.headers.Authorization = authHeader;
  }
  return config;
};

export const requestErrorInterceptor = (error: any) => {
  logger('error', error, 'error');
  return Promise.reject(error);
};
